import React from "react";
import "./style.css";
import {
  formatDate,
  getEventYear,
  getTime,
  moneyRoundOff,
} from "../../../../utils/func";
import { DEFAULT_CURRENCY } from "../../../../constants";
import { StarIcon } from "../../../../components/GlobalIcons";
import { Navigate, createSearchParams, useNavigate } from "react-router-dom";
import { TICKETSPAGE } from "../../../../constants/RoutingPath";

const EventMiniCard = ({ item, searchParams, setSearchParams }) => {
  const {
    event_name,
    tournament_type,
    date_start,
    date_stop,
    venue_name,
    city,
    iso_country,
    min_ticket_price_inr,
    is_popular,
    tournament_name,
    season,
  } = item;

  const splitted_Name = event_name.split("vs");
  const First_team = splitted_Name[0];
  const Second_team = splitted_Name[1];

  const navigate = useNavigate();

  const handleOpenEvent = (eventName) => {
    navigate({
      pathname: `/ticket/${eventName}`,
    });
  };

  return (
    <div
      className="team_battles"
      onClick={() => {
        handleOpenEvent(item.event_id);
      }}
    >
      <div className="teams_sec">
        <h3>
          {First_team && First_team}
          {Second_team && (
            <>
              <span>Vs</span>
              {Second_team}
            </>
          )}
          {is_popular > 0 && (
            <span>
              <StarIcon fillColor={"var(--yellow)"} />
            </span>
          )}
        </h3>
        <p>
          <span>{formatDate(date_start)}</span>
          {getTime(date_start, date_stop)}
        </p>
      </div>
      <div className="other_detail">
        <h6>
          {tournament_name} - <span>{season}</span>
        </h6>
        <h6>
          {venue_name} - <span>{`${city}(${iso_country})`}</span>
        </h6>
        <button>
          {DEFAULT_CURRENCY} {moneyRoundOff(min_ticket_price_inr)}{" "}
          <span className="icon">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
              <path
                d="M17.6623 10.729L12.4631 5.9364M17.6623 10.729L12.8697 15.9281M17.6623 10.729L8.91953 11.0847M4.33998 11.2711L6.42159 11.1864"
                stroke="black"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </button>
      </div>
    </div>
  );
};

export default EventMiniCard;
